import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { CTA } from "@/lib/ctas";
import AuditReassurance from "@/components/public/AuditReassurance";

export default function CTASection({
    title = "Ready when you are.",
    description = "Tell us what you're trying to build. We'll come back with a fixed price and a timeline within two working days.",
    primary = CTA.AUDIT,
    secondary = CTA.SEE_WORK,
}) {
    return (
        <section className="px-5 sm:px-8 lg:px-12 py-16" data-testid="cta-section">
            <div className="max-w-5xl mx-auto cta-band">
                <div className="eyebrow">— NEXT STEP</div>
                <h2
                    className="font-display mt-3 mx-auto"
                    style={{ fontSize: "clamp(28px, 4.5vw, 44px)", fontWeight: 700, lineHeight: 1.1, color: "var(--text)", maxWidth: "18em" }}
                >
                    {title}
                </h2>
                <p className="mt-5 mx-auto" style={{ fontSize: 16.5, maxWidth: 640, lineHeight: 1.6, color: "var(--muted)" }}>
                    {description}
                </p>
                <div className="mt-8 flex flex-wrap gap-3 justify-center items-start">
                    <div>
                        <Link to={primary.href} className="btn-primary" data-testid="cta-primary-button">
                            {primary.label} <ArrowRight className="w-4 h-4" />
                        </Link>
                        {primary.key === "audit" && <AuditReassurance align="center" />}
                    </div>
                    {secondary && (
                        <Link to={secondary.href} className="btn-ghost" data-testid="cta-secondary-button">
                            {secondary.label}
                        </Link>
                    )}
                </div>
            </div>
        </section>
    );
}
